import { render, staticRenderFns } from "./POSCategories.vue?vue&type=template&id=7b44cc08&"
import script from "./POSCategories.vue?vue&type=script&lang=js&"
export * from "./POSCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports